<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="dedication"><a id="page_7"></a>dedication</h2>
<p class="indent">Dedicated to all of the people who suffer with debilitating gut issues on a daily basis. And to my dear Dad (“Doc”) and my late Mom, whom I miss dearly. I have learned so much from them, and continue to learn the power of human compassion from my Dad. I love you both.<a id="page_8"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?33f4200e